import React, { createContext, useContext, type ComponentType, type ReactNode } from 'react';
import type { GEXLesson, GEXLessonId } from 'components/GEXEducation/lessons';

interface Props {
  id: GEXLessonId;
  lesson?: GEXLesson;
  children: ReactNode;
}

function PlainHelp({ children }: Props) {
  return <>{children}</>;
}

// GEX supplies its existing help component. Other trade-card consumers need only
// the children; importing the full guide here would put it back on every Flow route.
const CardEducation = createContext<{ enabled: boolean; Help: ComponentType<Props> }>({
  enabled: false,
  Help: PlainHelp,
});

export const MobileOptionCardEducationProvider = CardEducation.Provider;
export const useMobileOptionCardEducation = () => useContext(CardEducation);
